import { styled, SvgIconProps } from "@mui/material";
import { ReactComponent } from "../../assets/svg/devops-logo.svg";

const AzureDevOpsIconSvg = styled(ReactComponent)`
  & > path {
    fill: currentcolor;
  }
`;

const AzureDevOpsIcon = (props: SvgIconProps) => {
  return <AzureDevOpsIconSvg {...props} />;
};

export { AzureDevOpsIcon };
